import React, { useRef, useState, useEffect } from "react";
import {
  getPlasticSealList,
  updatePlasticSealStatus,
  getExportablePlasticSealList,
} from "src/services/plastic-seal.services";

import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
  CButtonGroup,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
  CFormSelect,
  CFormInput,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPencil, cilPlus, cilSearch } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import TableComponent from "./TableComponent";
import {
  pdf,
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
} from "@react-pdf/renderer";
import moment from "moment";
import { getActiveCountryList } from "src/services/country.services";
import Select from "react-select";

const PlasticSealManagementTable = () => {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const toaster = useRef();
  // const [toast, addToast] = useState("");
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [modalText, setModalText] = useState(null);
  const [plasticSealStatus, setPlasticSealStatus] = useState("");
  const [plasticSealExportableData, setPlasticSealExportableData] = useState(
    []
  );
  const [searchSerialNumber, setSearchSerialNumber] = useState("");
  const [sealArray, setSealArray] = useState([]);
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const defaultErrorMessage = "Something went wrong";

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") {
      getActiveCountries();
    }
  }, []);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") {
      getPlasticSealItem(
        currentPage,
        plasticSealStatus,
        selectedCountry?.value
      );
    } else {
      getPlasticSealItem(currentPage, plasticSealStatus);
    }
  }, [currentPage, selectedCountry, plasticSealStatus]);

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getPlasticSealItem = (
    page,
    status,
    country = null,
    searchValue = null
  ) => {
    setIsLoading(true);
    let searchParam = {
      limit,
      page,
    };
    if (status) searchParam.status = status;
    if (searchValue) searchParam.serial = searchValue;
    if (country) searchParam.country = country;

    getPlasticSealList(searchParam)
      .then(async (response) => {
        let pasticDataInfo = response.data;
        setIsLoading(false);
        setCount(response.count);
        setData(pasticDataInfo);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
        let sealsArray = [];
        pasticDataInfo.forEach((element) => {
          sealsArray.push(element.serialNo);
        });
        setSealArray(sealsArray);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getPlasticSealItem(newPage, plasticSealStatus);
  };

  const handleDamagedSerial = (id) => {
    setVisibleDeleteModal(true);
    setSelectedId(id);
    setModalText("Are you  sure to mark this as damaged?");
  };

  const handleConfirm = (value) => {
    setVisibleDeleteModal(false);
    if (value == "confirm") {
      const data = {
        status: "damaged",
      };
      toast
        .promise(
          updatePlasticSealStatus(data, selectedId),
          {
            loading: "Loading",
            success: "Plastic seal mark as damaged succesfully",
            error: (err) => {
              return err.response &&
                err.response.data &&
                err.response.data.message
                ? err.response.data.message
                : defaultErrorMessage;
            },
          },
          {
            id: "plastic-seal",
          }
        )
        .then(async (response) => {
          setSelectedId(null);
          getPlasticSealItem(currentPage, plasticSealStatus);
        })
        .catch((error) => console.error(error));
    }
  };

  const handleChangeStatus = (value) => {
    setPlasticSealStatus(value);
    setCurrentPage(1);
  };

  const exportToExcel = async () => {
    const param = {
      status: plasticSealStatus,
    };
    getExportablePlasticSealList(param)
      .then(async (response) => {
        setPlasticSealExportableData(response.data);
        const worksheet = XLSX.utils.json_to_sheet(response.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Plastic-Seal.xlsx");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchApiDataAndDownloadPDF = async () => {
    const param = {
      status: plasticSealStatus,
    };
    getExportablePlasticSealList(param)
      .then(async (response) => {
        generatePDF(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const generatePDF = async (data) => {
    const MyDocument = () => (
      <Document>
        <TableComponent data={data} />
      </Document>
    );

    const pdfBlob = await pdf(<MyDocument />).toBlob();
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Plastic-Seal.pdf";
    link.click();
  };

  const submitSearchButton = () => {
    if (searchSerialNumber) {
      let result = data.filter((item) => item.serialNo === searchSerialNumber);
      if (!result.length) {
        getPlasticSealItem(
          currentPage,
          plasticSealStatus,
          null,
          searchSerialNumber
        );
      } else {
        setData(result);
      }
    } else {
      getPlasticSealItem(currentPage, plasticSealStatus);
    }
  };

  const handleCountryChange = (selectedOption) => {
    setCurrentPage(1);
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
  };

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol md={userInfo?.userType === "superAdmin" ? 12 : 4}>
              <h4 id="traffic" className="card-title mb-0 place-content-center">
                Plastic Seal Management - Total: {count}
              </h4>
            </CCol>
            <CCol
              md={userInfo?.userType === "superAdmin" ? 12 : 8}
              className={`${userInfo?.userType === "superAdmin" ? "mt-2" : ""}`}
            >
              <div className="container-fluid px-0">
                <div className="row">
                  <CCol xs={6} md={userInfo?.userType === "superAdmin" ? 3 : 4}>
                    <CInputGroup className="mb-3">
                      <CFormInput
                        placeholder="Serial Number"
                        value={searchSerialNumber}
                        onChange={(e) => setSearchSerialNumber(e.target.value)}
                      />
                      <CInputGroupText>
                        <CIcon
                          icon={cilSearch}
                          onClick={submitSearchButton}
                          style={{ cursor: "pointer" }}
                        />
                      </CInputGroupText>
                    </CInputGroup>
                  </CCol>
                  {userInfo?.userType === "superAdmin" && (
                    <CCol xs={6} md={3}>
                      <Select
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        options={countrySelectOptions}
                        isClearable={true}
                        placeholder="Select Country"
                      />
                    </CCol>
                  )}

                  <CCol xs={6} md={userInfo?.userType === "superAdmin" ? 3 : 4}>
                    <CFormSelect
                      defaultValue={plasticSealStatus}
                      id={"priority"}
                      onChange={(e) => handleChangeStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="used">Used</option>
                      <option value="unUsed">Unused</option>
                      <option value="damaged">Damaged</option>
                    </CFormSelect>
                  </CCol>
                  <CCol xs={6} md={userInfo?.userType === "superAdmin" ? 3 : 4}>
                    <div className="d-flex justify-content-center pe-3">
                      <div className="w-50">
                        <CButtonGroup
                          role="group"
                          aria-label="Button group with nested dropdown"
                          className="w-100 flex-fill"
                        >
                          <CDropdown variant="btn-group flex-fill">
                            <CDropdownToggle
                              color="primary"
                              disabled={plasticSealStatus == ""}
                            >
                              Export
                            </CDropdownToggle>
                            <CDropdownMenu className="w-100">
                              <CDropdownItem
                                onClick={() => fetchApiDataAndDownloadPDF()}
                              >
                                as PDF
                              </CDropdownItem>
                              <CDropdownItem onClick={() => exportToExcel()}>
                                as Excel
                              </CDropdownItem>
                            </CDropdownMenu>
                          </CDropdown>
                        </CButtonGroup>
                      </div>
                      <div className="w-auto">
                        <Link
                          to="/create-plastic-seal"
                          className="ms-3 flex-fill"
                        >
                          <CButton className="w-100">
                            <CIcon icon={cilPlus} />
                            &nbsp; Create
                          </CButton>
                        </Link>
                      </div>
                    </div>
                  </CCol>
                  {/* <CCol xs={6} md={3} className="mt-3 mt-sm-0">
                    <Link to="/create-plastic-seal">
                      <CButton style={{ width: "100%" }}>
                        <CIcon icon={cilPlus} />
                        &nbsp; Create
                      </CButton>
                    </Link>
                  </CCol> */}
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable
            align="middle"
            className="mb-0 border text-center"
            hover
            responsive
          >
            <CTableHead color="light">
              <CTableRow>
                {/* <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell> */}
                <CTableHeaderCell className="text-center">
                  Serial
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Created At
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="6">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    {/* <CTableDataCell className="text-center">
                    <CAvatar
                      size="md"
                      src={item.avatar.src}
                      status={item.avatar.status}
                    />
                  </CTableDataCell> */}
                    <CTableDataCell>
                      <div>{item.serialNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.status == "unUsed" ? "Unused" : item.status}
                    </CTableDataCell>
                    <CTableDataCell>
                      {item.createdAt
                        ? moment(item.createdAt).format("DD/MM/YYYY")
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.status === "unUsed" ? (
                        <CButton
                          color="secondary"
                          onClick={(id) => handleDamagedSerial(item._id)}
                          style={{ color: "white" }}
                        >
                          Mark as Damaged
                        </CButton>
                      ) : (
                        ""
                      )}
                      {/* </Link> */}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <DeleteModal
        visible={visibleDeleteModal}
        onConfirm={handleConfirm}
        setVisibleDeleteModal={setVisibleDeleteModal}
        text={modalText}
        // addToast={addToast}
      />
      {/* <CToaster ref={toaster} push={toast} placement="top-end" /> */}
    </>
  );
};

export default PlasticSealManagementTable;
